import Table from "src/components/Common/UI/DndTable/Table";
import LoadingSpinner from "src/components/Common/UI/LoadingSpinner/LoadingSpinner";
import React from "react";
import { MisterIcon } from "@rtel/mister-icons";
import { Button } from "reactstrap";
import Modal from "src/components/Common/UI/Modal/Modal";
import CreatePhonecentersMaintenance from "./CreatePhonecentersMaintenance";
import { usePhonecentersMaintenancesDataViewLogic } from "./hooks/usePhonecentersMaintenanceDataViewLogic";
import EditPhonecentersMaintenance from "./EditPhonecentersMaintenance";
import DeletePhonecentersMaintenance from "./DeletePhonecentersMaintenance";
import TableActionButtons from "src/components/Common/UI/DndTable/ActionButtons/TableActionButtons";


const PhonecentersMaintenancesDataView = () => {

  const {
    data,
    columns,
    loadingDone,
    setSelectedRowsOfTable,
    selectedRowsOfTable,
    actionEvent,
    closeActionModal,
    getModalTitleByAction,
    t,
    modalEvent
  } = usePhonecentersMaintenancesDataViewLogic();

  const addPhonecentersMaintenanceButton: React.FC = () => {
    return (
      <Button
        type="button"
        color="dark"
        onClick={ () => { actionEvent({action: "create"}); }}
        className="mb-1"
        size="sm"
        data-toggle="modal"
      >
        <MisterIcon name="Plus" size="sm" className="icon-light" /> {t(`Νέος Συντηρητής`)}
      </Button>
    )
  };

  const ActionButtons: React.FC = () => (
    <TableActionButtons event={actionEvent} canEdit={selectedRowsOfTable.length > 0} canDelete={false} />
  );

  return (
    <>
        {loadingDone && (
          <>
            <Table
                columns={columns}
                data={data}
                defaultOrderByKeyFilter={"id"}
                showNumberOfRows={false}
                rowSelection={true}
                setRowSelection={setSelectedRowsOfTable}
                multipleRowSelection={false}
                actionRowId={"id"}
                debugMode={false}
                noDataFoundTitle="No PhonecentersMaintenances yet"
                isChangeOrderOrVisibilityEnable={false}
                ButtonsAreaLeft={ActionButtons}
                ButtonsAreaRight={addPhonecentersMaintenanceButton}
                textPosition="center"
            />
          </>
        )}

        <Modal
          isOpen={!!modalEvent.action}
          closeFilterModal={closeActionModal}
          title={getModalTitleByAction()}  
          >
            {modalEvent.action === "create" && <CreatePhonecentersMaintenance handleCloseModal={closeActionModal}/> }
            {modalEvent.action === "edit" && <EditPhonecentersMaintenance handleCloseModal={closeActionModal} phonecentersMaintenanceId={modalEvent.selectedRows ? modalEvent.selectedRows[0] : -1} />}
            {modalEvent.action === "delete" && <DeletePhonecentersMaintenance handleCloseModal={closeActionModal} phonecentersMaintenanceId={modalEvent.selectedRows ? modalEvent.selectedRows[0] : -1} />}
        </Modal>

        {!loadingDone && <LoadingSpinner />}
    </>
  )
}

export default PhonecentersMaintenancesDataView;

